import i18n from 'i18next';
import * as Sentry from '@sentry/browser';
import { switchLanguage } from 'common/i18n/i18n';
import UserAPI from 'common/services/UserAPI';
import UserProfileAPI from 'common/modules/userProfile/services/UserProfileAPI';
import SessionAPI from 'common/modules/session/services/SessionAPI';
import SessionStorage from 'common/modules/session/services/SessionStorage';
import User from 'common/domain/user';
import UserProfile from 'common/modules/userProfile/domain/UserProfile';
import ApiClient from 'common/services/api';
import AdvertiserProfileAPI from '../../advertiser/services/AdvertiserProfileAPI';
import { getToken } from '../selectors/sessionSelectors';
import type { GetState, Dispatch } from '../../../redux/types/redux';

export const BEGIN_SESSION = 'session/BEGIN_SESSION';
export const CLOSE_SESSION = 'session/CLOSE_SESSION';
export const RETRIEVE_NO_SESSION = 'session/RETRIEVE_NO_SESSION';
export const RENEW_SESSION = 'session/RENEW_SESSION';
export const RENEW_SESSION_SUCCESS = 'session/RENEW_SESSION_SUCCESS';
export const RENEW_SESSION_FAILED = 'session/RENEW_SESSION_FAILED';
export const UPDATE_USER = 'session/UPDATE_USER';

export const beginSession = (registration: ?{ token: ?string, profile: ?Object }) => {
  return async (dispatch: Dispatch) => {
    const session = SessionStorage.retrieveNotExpired();
    if (!session) {
      dispatch({ type: RETRIEVE_NO_SESSION });
      return;
    }

    if (registration && registration.token && registration.profile) {
      dispatch({ type: BEGIN_SESSION, user: registration.profile, token: registration.token });
      ApiClient.setAuthorization(registration.token);
      return;
    }

    try {
      const { token, refreshToken } = await SessionAPI.renewSession(session.refreshToken);
      const user = await UserAPI.fetchGeneralUserInformation(token);
      const advertiser = await AdvertiserProfileAPI.getUserAdvertiser(token);

      if (user.language !== i18n.language) {
        switchLanguage(() => {
        });
      }

      dispatch({
        type: BEGIN_SESSION, user, token, advertiser,
      });
      ApiClient.setAuthorization(token);
      SessionStorage.updateRefreshToken(refreshToken);
      SessionStorage.updateSentryUser(user, advertiser);

      Sentry.setUser(SessionStorage.retrieveSentryUser());
    } catch (error) {
      dispatch({ type: RETRIEVE_NO_SESSION });
    }
  };
};

export function closeSession() {
  return async (dispatch: Dispatch) => {
    SessionStorage.clear();

    ApiClient.removeAuthorization();

    dispatch({ type: CLOSE_SESSION });
  };
}

export function updateUser(updatedUser: User) {
  return async (dispatch: Dispatch, getState: GetState) => {
    const updatedUserProfile = await UserProfileAPI.updateProfile(getToken(getState()), UserProfile.parse(updatedUser));

    dispatch({
      type: UPDATE_USER,
      updatedUser: updatedUserProfile,
    });
  };
}

export const renewSession = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: RENEW_SESSION });

    const session = SessionStorage.retrieveNotExpired();
    if (!session) {
      dispatch({ type: RENEW_SESSION_FAILED });
      return;
    }

    const { refreshToken } = session;
    try {
      const newSession = await SessionAPI.renewSession(refreshToken);

      dispatch({ type: RENEW_SESSION_SUCCESS, token: newSession.token });
      ApiClient.setAuthorization(newSession.token);
      SessionStorage.updateRefreshToken(newSession.refreshToken);

      Sentry.setUser(SessionStorage.retrieveSentryUser());
    } catch (error) {
      dispatch({ type: RENEW_SESSION_FAILED });
      SessionStorage.clear();
    }
  };
};



// WEBPACK FOOTER //
// ./src/advertisers/modules/authentication/actions/sessionActions.js